import React from 'react';
import styles from './StatsBar.module.css';

const STATS = [
  { num: '100+', label: 'Fortune Companies Served' },
  { num: '5',    label: 'Core Service Verticals'   },
  { num: '7+',   label: 'IT Courses Offered'       },
  { num: '2',    label: 'Countries · India & USA'  },
];

export default function StatsBar() {
  return (
    <div className={styles.bar}>
      {STATS.map(({ num, label }, i) => (
        <div key={i} className={styles.stat}>
          <div className={styles.num}>{num}</div>
          <div className={styles.label}>{label}</div>
        </div>
      ))}
    </div>
  );
}
